export const DEBOUNCE_TIMEOUT = 1000;
export function isSnowplowReady() {
    return !!window.snowplowVendor;
}
export function setUserId(userId) {
    if (isSnowplowReady()) {
        window.snowplowVendor.setUserId(userId);
    }
    else {
        window.spUID = userId;
    }
}
export function firePageView(title) {
    if (isSnowplowReady()) {
        window.snowplowVendor.firePageView({
            title: title,
        });
    }
}
export function trackComponent(componentType, componentName, actionName, label, options) {
    if (isSnowplowReady()) {
        window.snowplowVendor.trackComponent(Object.assign({ componentType: componentType, componentName: componentName, actionName: actionName, label: label }, options));
    }
}
export function trackComponentClick(componentType, name, label) {
    trackComponent(componentType, name, 'click', label);
}
export function trackButtonClick(name, label) {
    trackComponentClick('Button', name, label);
}
export function trackCheckboxSelect(name, label) {
    trackComponent('Checkbox', name, 'select', label);
}
export function trackPageType(page, pageType) {
    trackComponent('Page', page, 'Page View', page, {
        value: [
            {
                pageType: pageType,
            },
        ],
    });
}
const UNKNOWN_USER = 'Unknown';
export function trackUnknownUser(userData) {
    const component = 'Auth';
    const action = 'Login';
    if (getUserId(userData) === UNKNOWN_USER)
        trackComponent(component, component, action, action, {
            value: [
                {
                    user: userData,
                },
            ],
        });
}
function isOIDC(userData) {
    return userData.nonce !== undefined;
}
export function getUserId(userData) {
    const fullName = !!userData.given_name && !!userData.family_name
        ? `${userData.given_name} ${userData.family_name}`
        : '';
    let fallBackId = '';
    if (isOIDC(userData)) {
        fallBackId = userData.preferred_username || userData.name || userData.profile;
    }
    else {
        fallBackId = userData.hub_id;
    }
    return userData.email || fullName || fallBackId || UNKNOWN_USER;
}
export function trackMediaPLayerEvent({ title, eventType, duration, currentTime, startTime, endTime, }) {
    trackComponent('Video Player', 'Video Player', eventType, 'Video Player', {
        value: [
            {
                eventType,
                duration,
                currentTime,
                title,
                startTime,
                endTime,
            },
        ],
    });
}
